import { useEffect, useState } from "react";
import useDeviceAccess from "./hooks/useDeviceAccess";

function BlockedPopup(props) {
    const device = props.device;
    const handleClose = props.handleClose;

    return (
        <div>
        <div className="fixed inset-0 bg-gray-900 opacity-70 z-20"></div>
        <div className="absolute inset-0 z-30">
            <div className="flex items-center w-full h-full flex-col">
                <div className="flex flex-col items-center w-1/2 h-1/3">
                    <img className="h-40" src="/images/up_white.png" alt="Up arrow" />
                    <img src="/images/blocked.png" alt="blocked message" />
                    <h2 className="text-white text-2xl font-bold mt-12 text-center">Your  { device } is blocked</h2>
                    <ul className="list-disc text-white mt-3">
                        <li>Click on the above icon in your browser toolbar</li>
                        <li>Select allow access and refresh the page</li>
                    </ul>
                    <button  type="button" className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        onClick={handleClose}
                    >Continue without { device }</button>
                </div>
            </div>
        </div>
        </div>
    )
}

function DeviceBlockedPopup(props) {
    const cameraAccessBlocked = props.cameraAccessBlocked;
    const microphoneAccessBlocked = props.microphoneAccessBlocked;

    const [continueWithoutDevice, setContinueWithoutDevice] = useState(false);

    if (continueWithoutDevice) {
        return <div></div>
    }

    if (cameraAccessBlocked) {
        return  <BlockedPopup device="camera" handleClose={()=> {setContinueWithoutDevice(true)}} />
    }

    if (microphoneAccessBlocked) {
        return <BlockedPopup device="microphone" handleClose={()=>{setContinueWithoutDevice(true)}} />
    }

    return  <div></div>

}

export default DeviceBlockedPopup;